var map = {
	"./127 TPH WHRB boiler erection photo at Shyam Metalic, Sambalpur, Odisha/1.jpeg": 8453,
	"./127 TPH WHRB boiler erection photo at Shyam Metalic, Sambalpur, Odisha/2.jpeg": 1460,
	"./127 TPH WHRB boiler erection photo at Shyam Metalic, Sambalpur, Odisha/3.jpeg": 4203,
	"./155 TPH CFBC boiler screen coil replacement - facor vedanta/1.jpeg": 1707,
	"./155 x 9 CFBC Boiler AOH photo at Hindalco, Hirakud, Odisha./1.jpeg": 1701,
	"./155 x 9 CFBC Boiler AOH photo at Hindalco, Hirakud, Odisha./2.jpeg": 3140,
	"./210 TPH CABC boilers pressure part revamping photo at JSW BPSL, Sambalpur, Odisha./1.jpg": 834,
	"./210 TPH CABC boilers pressure part revamping photo at JSW BPSL, Sambalpur, Odisha./2.jpg": 4381,
	"./210 TPH CABC boilers pressure part revamping photo at JSW BPSL, Sambalpur, Odisha./3.jpeg": 3177,
	"./210 TPH CABC boilers pressure part revamping photo at JSW BPSL, Sambalpur, Odisha./4.jpeg": 3404,
	"./210 TPH CABC boilers pressure part revamping photo at JSW BPSL, Sambalpur, Odisha./5.jpeg": 3667,
	"./210 TPH CABC boilers pressure part revamping photo at JSW BPSL, Sambalpur, Odisha./6.jpeg": 1334,
	"./210 TPH CABC boilers pressure part revamping photo at JSW BPSL, Sambalpur, Odisha./7.jpeg": 6301,
	"./210 TPH CABC boilers pressure part revamping photo at JSW BPSL, Sambalpur, Odisha./8.jpeg": 384,
	"./Featured/Featured1.jpeg": 7427,
	"./Featured/Featured2.jpeg": 4950,
	"./Featured/Featured3.jpeg": 3213,
	"./Featured/Featured4.jpeg": 6952,
	"./Featured/Featured5.jpeg": 4543
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6653;